'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {"alloy-card":"Card-module_alloy-card__SuHaS","alloy-card--md":"Card-module_alloy-card--md__Jduw8"};

exports.default = styles;
//# sourceMappingURL=Card.module.scss.js.map
